// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cs-avatar[data-v-b43a8d40] {\n  justify-self: center;\n}", ""]);
// Exports
module.exports = exports;
